import { Form } from 'react-bootstrap';
import { ObjectValueEditForm } from './ObjectValueEditForm';
import { ObjectCustomField } from '@/backend/models/customFields/objectCustomField';
import { ObjectProperty } from '@/backend/models/objectInstance';
import { useParameterStore } from '@/frontend/store/ParameterStore';
import { ObjectKeyVisibility } from '@/types/customFieldTypes';

export function PropertyEdit(props: {
    property: ObjectProperty,
    runView: boolean,
    customField: ObjectCustomField,
  }) {
  const handleUpdatedConsumers = useParameterStore(state => state.handleUpdatedParamsAndRefs);
  const { property, runView, customField } = props;

  if (runView && property.visibility === ObjectKeyVisibility.HIDDEN && !customField.isCustomChoice) {
    return null;
  }

  return (
    <div className="w-100" key={property.keyId}>
      <Form.Label className="form-label-neutral">{property.title || property.key}</Form.Label>
      {property.description && <div className="form-description-neutral">{property.description}</div>}
      <ObjectValueEditForm
        property={property}
        handleUpdatedConsumers={handleUpdatedConsumers}
        disabled={runView && property.visibility === ObjectKeyVisibility.VIEW_ONLY && !customField.isCustomChoice}
      />
    </div>
  );
}
